import rootService from 'core/services.root';

export default rootService({
    createOtt: ['POST', '/user/ott/store'],
    getCheckExternalToken: ['PUT', '/user/ott/validate', { noRedirect: true }],
    getResetPassword: ['GET', '/user/recover-password/:identification?profile=admin'],
    getVersion: ['GET', '/configurations/version'],
    login: ['POST', '/auth/login', { noRedirect: true }],
    logout: ['POST', '/auth/logout'],
    validateToken: ['GET', '/user/token/validate?role=admin']
});
